const ABRE = /^<\w[^>]*[^/]>$/;
const FECHA_NA_LINHA = /<\/[\w:]+>$/;
const FECHA = /^<\/\w/;

export function formatarXml(xml) {
	let nivel = 0;

	return xml
		.replace(/>\s*</g, ">\n<")
		.split("\n")
		.map((linha) => {
			if (FECHA.test(linha)) nivel -= 1;

			const recuo = "  ".repeat(Math.max(nivel, 0));

			if (ABRE.test(linha) && !FECHA_NA_LINHA.test(linha)) nivel += 1;

			return recuo + linha;
		})
		.join("\n");
}
